import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import FormFormat from "./Form";

const EditForm = () => {
  return (
    <div>
      <h1>Edit Form</h1>
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/admin" }}>
          Dashboard
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Master</Breadcrumb.Item>
        <Breadcrumb.Item active>Edit Form</Breadcrumb.Item>
      </Breadcrumb>

      <FormFormat />
    </div>
  );
};

export default EditForm;
